import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Genre from '../../../domain/entities/Genre';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexGenresSuccess: {
      const result = action.payload as PaginatedResult<Genre>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
